import { Routes } from '@angular/router';
import { LandingPageComponent } from '@app/home/landing-page/landing-page.component';
import { AboutComponent } from '@app/home/about/about.component';
import { SettingsComponent } from './shared/components/settings/settings.component';
import { ImprintComponent } from './shared/components/imprint/imprint.component';
import { LexiconComponent } from './shared/components/lexicon/lexicon.component';
import { TemplatesComponent } from './shared/components/templates/templates.component';
import { ContactComponent } from './shared/components/contact/contact.component';
import { LexiconDetailComponent } from './shared/components/lexicon-detail/lexicon-detail.component';
import { ProfileComponent } from './shared/components/profile/profile.component';
import { InstructionComponent } from './shared/components/instruction/instruction.component';
import { ChildAdminComponent } from './shared/components/child-admin/child-admin.component';
import { TutorialComponent } from './shared/components/tutorial/tutorial.component';
import { FavoriteListComponent } from './station/favorite-list/favorite-list.component';


export const appRoutes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    pathMatch: 'full'
  },
  {
    path: 'exhibition',
    loadChildren: () => import('./exhibition/exhibition-routes')
      .then(m => m.exhibitionRoutes)
  },
  {
    path: 'about',
    component: AboutComponent
  },
  {
    path: 'settings',
    component: SettingsComponent
  },
  {
    path: 'imprint',
    component: ImprintComponent
  },
  {
    path: 'privacy',
    component: ImprintComponent
  },
  {
    path: 'landing-page',
    component: LandingPageComponent
  },
  {
    path: 'lexicon',
    component: LexiconComponent
  },
  {
    path: 'lexicon/:_route',
    component: LexiconDetailComponent
  },
  {
    path: 'templates',
    component: TemplatesComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'profile',
    component: ProfileComponent
  },
  {
    path: 'instruction',
    component: InstructionComponent
  },
  {
    path: 'tutorial',
    component: TutorialComponent
  },
  {
    path: 'child-admin',
    component: ChildAdminComponent
  },
  {
    path: 'favorites',
    component: FavoriteListComponent
  }
];
